(function () {
  const forceSingleLine = (slide) => {
    if (window.innerWidth >= 750) return;
    $(slide).find('.announcement-bar__text-wrapper').each(function () {
  $(this).css({
    'display': 'flex',
    'flex-direction': 'row',
    'flex-wrap': 'nowrap',
    'align-items': 'center',
    'white-space': 'nowrap',
    'overflow': 'hidden',
    'width': '100%',
    'gap': '0.3rem'
  });
  $(this).find('p').css({
    'white-space': 'nowrap',
    'overflow': 'hidden',
    'text-overflow': 'ellipsis',
    'display': 'block',
    'flex-shrink': '1',
    'margin': '0',
    'min-height': '0'
  });
});
  };

  const announcementSlider = () => {
    $(".announcement-bar__slide").each(function () {
      // Prevent double-initialising
      if ($(this).hasClass("slider_started")) {
        return;
      }

      // Only bother if there is more than 1 slide
      const slides = $(this).find(".swiper-slide");
      if (slides.length < 2) {
        return;
      }

      $(this).addClass("slider_started");

      const announcementId = $(this).data("announcement-id");

      // Make sure Swiper exists
      if (typeof Swiper === "undefined") {
        console.warn("Swiper is not defined for announcement bar");
        return;
      }

      // Force single line on mobile for all slides
      const self = this;
      $(this).find('.swiper-slide').each(function () {
        forceSingleLine(this);
      });

      const announcementSwiper = new Swiper(`.announcement-js-${announcementId}`, {
        loop: true,
        autoplay: {
          delay: 2500,
          disableOnInteraction: false
        },
        speed: 400,
        navigation: {
          nextEl: `#shopify-section-${announcementId} .announcement-btn-next`,
          prevEl: `#shopify-section-${announcementId} .announcement-btn-prev`
        },
        on: {
          slideChange: function () {
            $(self).find('.swiper-slide-active').each(function () {
              forceSingleLine(this);
            });
          }
        }
      });
    });
  };

  // Initial load
  document.addEventListener("DOMContentLoaded", announcementSlider);

  // When editing in Theme customiser
  document.addEventListener("shopify:section:load", function () {
    announcementSlider();
  });
})();